<template>
    <div id="login">
        <!-- LOGO -->
        <span class="logo"></span>

        <!-- FORM -->
        <form id="loginform" class="wrap" @submit="tryLogin">
            <label for="login">
                <input type="email" id="loginput" v-model="email" name="login" value="" placeholder="Adresse Email"
                       autocomplete="on">
                <i class="icon-user"></i>
            </label>
            <label for="password">
                <input id="password" type="password" v-model="password" name="pwd" value="" placeholder="Mot de passe"
                       autocomplete="on">
                <i class="icon-key"></i>
            </label>
            <div class="buttons">
                <input type="submit" name="submit" value="Connexion" style="height: 50px">
                <button v-if="isMobile() === true" @click.prevent="launchAuth()" style="height: 50px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 3H5a2 2 0 0 0-2 2v2m14-4h2a2 2 0 0 1 2 2v2m-5 1v2M8 8v2m1 6s1 1 3 1s3-1 3-1m-3-8v5h-1m-4 8H5a2 2 0 0 1-2-2v-2m14 4h2a2 2 0 0 0 2-2v-2"/></svg>
                    &nbsp;
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 512 512"><path fill="currentColor" d="M390.42 75.28a10.45 10.45 0 0 1-5.32-1.44C340.72 50.08 302.35 40 256.35 40c-45.77 0-89.23 11.28-128.76 33.84C122 77 115.11 74.8 111.87 69a12.4 12.4 0 0 1 4.63-16.32A281.8 281.8 0 0 1 256.35 16c49.23 0 92.23 11.28 139.39 36.48a12 12 0 0 1 4.85 16.08a11.3 11.3 0 0 1-10.17 6.72m-330.79 126a11.73 11.73 0 0 1-6.7-2.16a12.26 12.26 0 0 1-2.78-16.8c22.89-33.6 52-60 86.69-78.48c72.58-38.84 165.51-39.12 238.32-.24c34.68 18.48 63.8 44.64 86.69 78a12.29 12.29 0 0 1-2.78 16.8a11.26 11.26 0 0 1-16.18-2.88c-20.8-30.24-47.15-54-78.36-70.56c-66.34-35.28-151.18-35.28-217.29.24c-31.44 16.8-57.79 40.8-78.59 71a10 10 0 0 1-9.02 5.08M204.1 491a10.66 10.66 0 0 1-8.09-3.6C175.9 466.48 165 453 149.55 424c-16-29.52-24.27-65.52-24.27-104.16c0-71.28 58.71-129.36 130.84-129.36S387 248.56 387 319.84a11.56 11.56 0 1 1-23.11 0c0-58.08-48.32-105.36-107.72-105.36S148.4 261.76 148.4 319.84c0 34.56 7.39 66.48 21.49 92.4c14.8 27.6 25 39.36 42.77 58.08a12.67 12.67 0 0 1 0 17a12.44 12.44 0 0 1-8.56 3.68m165.75-44.4c-27.51 0-51.78-7.2-71.66-21.36a129.1 129.1 0 0 1-55-105.36a11.57 11.57 0 1 1 23.12 0a104.28 104.28 0 0 0 44.84 85.44c16.41 11.52 35.6 17 58.72 17a147.4 147.4 0 0 0 24-2.4c6.24-1.2 12.25 3.12 13.4 9.84a11.92 11.92 0 0 1-9.47 13.92a152.3 152.3 0 0 1-27.95 2.88ZM323.38 496a13 13 0 0 1-3-.48c-36.76-10.56-60.8-24.72-86-50.4c-32.37-33.36-50.16-77.76-50.16-125.28c0-38.88 31.9-70.56 71.19-70.56s71.2 31.68 71.2 70.56c0 25.68 21.5 46.56 48.08 46.56s48.08-20.88 48.08-46.56c0-90.48-75.13-163.92-167.59-163.92c-65.65 0-125.75 37.92-152.79 96.72c-9 19.44-13.64 42.24-13.64 67.2c0 18.72 1.61 48.24 15.48 86.64c2.32 6.24-.69 13.2-6.7 15.36a11.34 11.34 0 0 1-14.79-7a276.4 276.4 0 0 1-16.88-95c0-28.8 5.32-55 15.72-77.76c30.75-67 98.94-110.4 173.6-110.4c105.18 0 190.71 84.24 190.71 187.92c0 38.88-31.9 70.56-71.2 70.56s-71.2-31.68-71.2-70.56c.01-25.68-21.49-46.6-48.07-46.6s-48.08 20.88-48.08 46.56c0 41 15.26 79.44 43.23 108.24c22 22.56 43 35 75.59 44.4c6.24 1.68 9.71 8.4 8.09 14.64a11.39 11.39 0 0 1-10.87 9.16"/></svg>
                </button>
            </div>
        </form>

        <div class="sub-buttons">
            <!-- RESET PASSWORD -->
            <a href="https://admin.fi360.fr/resetting/request" id="forget-pwd" style="margin-bottom: 5px">Mot de passe oublié</a>
        </div>

        <div class="buttons">
            <!--  CLEAR STORAGE -->
            <a href="javascript: void 0" @click.prevent="clearCache">Vider les données</a>
        </div>

        <div class="buttons">
            <!-- RELOAD PAGE -->
            <a href="javascript: void 0" @click.prevent="updateFront">Mettre à jour</a>
        </div>

        <div class="buttons">
            <a :href="urlSSO" style="background-color: #5698d2">Connexion réservée SSO</a>
        </div>

    </div>
</template>

<script>

    import Security from '../../js/core/Security'
    import Api from '../../js/core/Api'
    import Config from "@/js/config";

    export default {
        data() {
            return {
                email: '',
                password: '',
                urlSSO: Config.keycloak.url
            }
        },
        methods: {
            updateFront(){

                swal({
                    title: 'Mise à jour',
                    text: 'Mise à jour de l\'application effectué',
                    type: 'info',
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                }).then(
                    async () => {

                        let isNew = false;

                        if (window.flutter_inappwebview !== undefined) {
                            isNew = await window.flutter_inappwebview.callHandler('handlerIsNew');
                        }

                        if (window.isMobile() && isNew) {
                            window.wantReload();
                        }
                    }
                )

            },

            clearCache() {

                swal({
                    title: 'Attention',
                    text: "Supprimer les données ? Tout ce que vous aurez saisi et pas synchronisé sera perdu",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'NON',
                    confirmButtonText: 'OUI'
                }).then(
                    () => {
                        localforage
                            .clear()
                            .then(() => {
                                swal({
                                    text: 'les données ont bien été supprimées',
                                    type: 'success'
                                })
                            })
                    },

                    () => {
                        swal.close()
                    }
                )
            },

            async tryLogin(e) {

                if(typeof e !== 'undefined') {
                    e.preventDefault();
                }

                let router = this.$router;
                let security = new Security;

                if (navigator.onLine) {
                    if(this.email == ""){
                        const emailEl = document.getElementById('loginput');
                        if (emailEl) this.email = emailEl.value;
                    }

                    if(this.password == ""){
                        const passwordEl = document.getElementById('password');
                        if (passwordEl) this.password = passwordEl.value;
                    }

                    security.login(this.email, this.password, (result) => {

                        if (result.status === true) {
                            if (window.isMobile() == true) {
                                if (typeof window.flutter_inappwebview !== 'undefined') {
                                    window.flutter_inappwebview.callHandler('saveCredentials', this.email, this.password).then(() => {
                                        console.log('Credentials saved');
                                    });
                                }
                            }

                            const redirectAfterLogin = () => {
                                router.push('init');
                            };

                            security.setUserSession(result.apiKey, function (res) {



                                if (res.status === true) {

                                    Api
                                        .init()
                                        .then(api => {

                                            api
                                                .get('/messages')
                                                .then(res => {

                                                    // TODO : AFFICHE LE MESSAGE ICI

                                                    if (res && res.data && !res.data.errors && res.data.hasOwnProperty('messages') &&
                                                        res.data.messages.length !== 0 &&
                                                        !localStorage.getItem('msg-'+res.data.messages[0].id)) {

                                                        let message = res.data.messages[0];
                                                        let opt = {};

                                                        opt.title = message.title;

                                                        if(message.html){
                                                            opt.html = message.message
                                                        } else {
                                                            opt.text = message.message
                                                        }

                                                        opt.type = message.type;

                                                        localStorage.setItem('msg-'+message.id, JSON.stringify(true));

                                                        swal(opt).then(() => redirectAfterLogin())

                                                    } else {

                                                        redirectAfterLogin()

                                                    }

                                                })
                                                .catch(() => redirectAfterLogin())

                                        })
                                        .catch(() => redirectAfterLogin())


                                } else {

                                    swal('Erreur',"Erreur lors de l'initialisation de la session " + JSON.stringify(res.error), 'error')

                                }

                            })

                        } else {
                            swal('Erreur', result.error, 'error')
                        }

                    })

                } else {

                    const storedPwd = localStorage.getItem('pwd');
                    const storedEmail = localStorage.getItem('email');
                    const inputHash = await Security.hashPassword(this.password).catch(() => null);
                    const passwordMatches = storedPwd && (storedPwd === inputHash || storedPwd === this.password);
                    if(passwordMatches && storedEmail === this.email){

                        let now = moment().format();

                        const redirectAfterLogin = () => {
                            router.push('init');
                        };

                        localforage
                            .setItem('lastConnexion', now)
                            .then(() => redirectAfterLogin())
                            .catch()

                    } else {
                        swal('Erreur', 'Veuillez vous connecter à internet.', 'error')
                    }
                }
            },

            getEmailIfExist() {
                localforage
                    .getItem('profil')
                    .then(res => {
                        if (res !== null) {
                            let usr = JSON.parse(res);
                            if (usr.hasOwnProperty('username') && usr.username !== '') {
                                this.email = usr.username
                            }
                        }
                    })
                    .catch()
            },
            b64DecodeUnicode(str) {
                // Going backwards: from bytestream, to percent-encoding, to original string.
                return decodeURIComponent(atob(str).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
            },
            fillFields(mail, pswd) {
                this.email = mail;
                this.password = pswd;

                this.tryLogin();
            },
            launchAuth() {
                if (window.isMobile() == true) {
                    if (typeof window.flutter_inappwebview !== 'undefined') {
                        window.flutter_inappwebview.callHandler('handlerGetCredentials').then((res) => {
                            if (res !== null) {
                                this.fillFields(res.email, res.password);
                            }
                        });

                    }
                }
            },
            isMobile() {
                return window.isMobile();
            }

        },
        mounted() {
            if (!navigator.onLine) {
                swal('Erreur', 'Veuillez vous connecter à internet.', 'error')
            }

            this.getEmailIfExist();

        }
    }

</script>

<style>

    #login {
        padding-top: 20px;
    }

    #login .wrap {
        max-width: 300px;
    }

    #login .wrap label {
        display: block;
        position: relative;
        height: 60px;
        margin-bottom: 20px;
        width: 100%;
    }

    #login .wrap label i {
        position: absolute;
        left: 10px;
        top: 13px;
        color: #ccc;
        font-size: 3.4rem;
    }

    #login .wrap label input {
        width: 100%;
        height: 60px;
        padding-left: 70px;
        font-size: 1.8rem;
        border: 1px solid #ccc;
        color: #999;
    }

    #login .wrap label input:focus {
        color: #5698d2;
        border-color: #5698d2;
    }

    #login .wrap label input:focus + i {
        color: #5698d2;
    }

    #login .wrap label + label {
        margin-bottom: 25px;
    }

    #login .wrap label + input {
        height: 60px;
        width: 100%;
        margin: auto;
        margin-bottom: 50px;
        font-size: 1.8rem;
        font-weight: 700;
        letter-spacing: 0.3rem;
        display: block;
    }

    #login a {
        display: block;
        text-align: center;
        font-size: 1.4rem;
    }

</style>

<style scoped>
    .buttons {
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .buttons input[type="submit"],
    .buttons button {
        margin: 10px 5px 15px 5px;
    }

    .buttons a {
        color: white;
        background-color: #5698d2;
        padding: 10px 15px;
        border-radius: 5px;
        font-size: 20px;
        font-weight: bold;
        text-decoration: none;
        height: 100%;
        margin: 0 5px 5px 5px;
        width: 200px;
    }

    .sub-buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .sub-buttons a {
        color: white;
        background-color: #5698d2;
        padding: 10px 15px;
        border-radius: 5px;
        font-size: 20px;
        font-weight: bold;
        text-decoration: none;
        width: 200px;
    }
</style>



// WEBPACK FOOTER //
// Login.vue?e8534606